module.exports = __webpack_public_path__ + "img/36.41abd998.png";